import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createAuditReport } from "../../../services/AuditService";

const GenerateAuditReportModal = () => {
  const location = useLocation();
  const data = location.state?.data || {};
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [dataInput, setDataInput] = useState({
    checklist: data?.checklist?.map((item) => ({
      checklist_id: item.id,
      response: "Yes", 
      evidence: null,
      remark: "",
    })) || [],
  });
  const navigate = useNavigate();

  const handleChange = (e, index) => {
    const { name, value, files } = e.target;
    setDataInput((prev) => {
      const updatedChecklist = [...prev.checklist];
      updatedChecklist[index][name] = files ? files[0] : value;
      return { ...prev, checklist: updatedChecklist };
    });
  };

  const handleResponseChange = (itemId, value) => {
    setDataInput((prev) => ({
      ...prev,
      checklist: prev.checklist.map((item) =>
        item.checklist_id === itemId ? { ...item, response: value } : item
      ),
    }));
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitLoading(true);
      const formData = new FormData();
      formData.append("schedule_id", data.schedules[0].id);

      dataInput.checklist.forEach((item, index) => {
        formData.append(`checklist[${index}][checklist_id]`, item.checklist_id);
        formData.append(`checklist[${index}][response]`, item.response);
        formData.append(`checklist[${index}][remark]`, item.remark);
        if (item.evidence) {
          formData.append(`checklist[${index}][evidence]`, item.evidence);
        }
      });

      const response = await createAuditReport(formData);
      toast.success(response.data.message);
      navigate(`/audit/${data.id}`);
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(`/audit/${data.id}`);
  };

  return (
    <div className="container-fluid">
      <div className="row px-2">
        <div className="col-xl-12">
          <div className="card shadow-sm">
            <div className="card-header py-3">
              <h4 className="mb-0">Audit Checklist</h4>
            </div>
            <div className="card-body">
              {data.checklist.map((item, index) => (
                <div key={item.id} className="mb-4 row">
                    <h4><strong>{index+1}. </strong>Checklist{index+1}</h4>
                  <div className="col-md-4 mt-4">
                    <div className="mb-3">
                      <strong>Checklist:</strong>
                      <span className="ms-2">{item?.title}</span>
                    </div>
                    <div className="mb-3">
                      <strong>Description:</strong>
                      <span className="ms-2">{item?.description}</span>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Response:</label>
                      <div className="d-flex align-items-center">
                        <div className="form-check me-3">
                          <input
                            type="radio"
                            id={`yes-${item.id}`}
                            name={`response-${item.id}`}
                            className="form-check-input"
                            value="Yes"
                            checked={dataInput.checklist[index]?.response === "Yes"}
                            onChange={(e) => handleResponseChange(item.id, e.target.value)}
                          />
                          <label htmlFor={`yes-${item.id}`} className="form-check-label">
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            type="radio"
                            id={`no-${item.id}`}
                            name={`response-${item.id}`}
                            className="form-check-input"
                            value="No"
                            checked={dataInput.checklist[index]?.response === "No"}
                            onChange={(e) => handleResponseChange(item.id, e.target.value)}
                          />
                          <label htmlFor={`no-${item.id}`} className="form-check-label">
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="mb-3">
                      <label htmlFor={`evidence-${item.id}`} className="form-label">
                        Upload Evidence:
                      </label>
                      <input
                        type="file"
                        id={`evidence-${item.id}`}
                        className="form-control"
                        name="evidence"
                        onChange={(e) => handleChange(e, index)}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor={`remark-${item.id}`} className="form-label">
                        Remarks:
                      </label>
                      <textarea
                        id={`remark-${item.id}`}
                        className="form-control"
                        rows="2"
                        value={dataInput.checklist[index]?.remark || ""}
                        name="remark"
                        onChange={(e) => handleChange(e, index)}
                      />
                    </div>
                  </div>
                </div>
              ))}
              <div className="d-flex justify-content-end mt-4">
                <button
                  type="button"
                  className="btn btn-primary me-3"
                  onClick={handleSubmit}
                  disabled={isSubmitLoading}
                >
                  {isSubmitLoading ? "Submitting..." : "Submit"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenerateAuditReportModal;
